import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../../helper/api";

export const markSeenAll = createAsyncThunk(
  "markSeenAll/markSeenAllNotification",
  async (payload, thunkAPI) => {
    try {
      const response = await api.post(
        "notification/mark-seen-all",
        payload
      );
      return response.data;
    } catch (error) {
      return thunkAPI.rejectWithValue({
        status: error.response?.status,
        message: error.response?.data?.message || "Unknown error",
      });
    }
  }
);

const markSeenAllSlice = createSlice({
  name: "markSeenAll",
  initialState: {
    data: null,
    loading: false,
    error: null,
  },

  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(markSeenAll.pending, (state) => {
        state.loading = true;
      })
      .addCase(markSeenAll.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(markSeenAll.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default markSeenAllSlice.reducer;
